import axios from "axios";
import { Config } from "../config";
import { useQuery } from "react-query";

const userMicroserviceBaseURL = Config.serviceUrls.userBaseUrl;

const staffRepository = {};

staffRepository.getUserOfficesWhereStaffIsAdmin = async (userId) => {
  try {
    let response = await axios.get(
      `${userMicroserviceBaseURL}/Staff/${userId}/AdminUserOfficeList`,
    );
    return response.data;
  } catch (e) {
    return { message: e.message };
  }
};

staffRepository.getSubstitutes = async (userId, officeId) => {
  try {
    let response = await axios.get(
      `${userMicroserviceBaseURL}/Staff/CompatibleAdminList`,
      {
        params: {
          staffMemberId: userId,
          officeId: officeId,
        },
      },
    );
    return response.data;
  } catch (e) {
    return { message: e.message };
  }
};

staffRepository.activateStaff = async (userId, officeId) => {
  return await staffRepository.updateStaffStatus(userId, officeId, true);
};

staffRepository.deactivateStaff = async (
  userId,
  officeId,
  transferWorkItemsTo,
) => {
  return await staffRepository.updateStaffStatus(
    userId,
    officeId,
    false,
    transferWorkItemsTo,
  );
};

staffRepository.updateStaffStatus = async (
  userId,
  officeId,
  status,
  transferWorkItemsTo,
) => {
  try {
    let response = await axios.patch(`${userMicroserviceBaseURL}/Staff`, {
      staffMemberId: userId,
      officeId,
      status,
      transferWorkItemsTo,
    });

    return response.data;
  } catch (e) {
    return { message: e.message };
  }
};

staffRepository.removeStaff = async (userId, officeId, transferWorkItemsTo) => {
  try {
    let response = await axios.delete(`${userMicroserviceBaseURL}/Staff`, {
      params: {
        staffMemberId: userId,
        officeId,
        transferWorkItemsTo,
      },
    });

    return response.data;
  } catch (e) {
    return { message: e.message };
  }
};

export async function getDepartmentListByOwnerId(ownerId = "") {
  const response = await axios.get(
    `${userMicroserviceBaseURL}/Department/GetAllByOwnerId?ownerId=${ownerId}`,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data.data;
}

export function useGetDepartmentListByOwnerId(ownerId, options = {}) {
  return useQuery(
    ["/Department/GetAllByOwnerId", ownerId],
    () => getDepartmentListByOwnerId(ownerId),
    options,
  );
}

export async function addDepartmentName(params) {
  const response = await axios.post(
    `${userMicroserviceBaseURL}/Department`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}
export async function editDepartmentName(params) {
  const response = await axios.put(
    `${userMicroserviceBaseURL}/Department`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}

export async function deleteDepartmentName(params) {
  const response = await axios.delete(
    `${userMicroserviceBaseURL}/Department?Id=${params.Id}&OwnerId=${params.OwnerId}`,
    { data: params },
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}
const createStringForParams = (params) =>
  Object.entries(params).reduce((prev, [key, value], i) => {
    if (Array.isArray(value)) {
      value.forEach((res) => {
        prev += (i ? "&" : "") + key + "=" + res;
      });
    } else {
      prev += (i ? "&" : "") + key + "=" + value;
    }
    return prev;
  }, "");
export async function exportStaff(params) {
  const response = await axios.get(
    `${userMicroserviceBaseURL}/Staff/GetGlobalStaffExport?${createStringForParams(
      params,
    )}`,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}
export async function getGlobalStaff(params) {
  // const values = createStringForParams(
  //   params
  // )`{{userBaseUrl}}/Staff/GetGlobalStaff?SearchTerm=Ziya&designationIds=180&officeIds=5500&ownerId=5911&departmentIds=1&reportToIds=101&pageNumber=1&pageSize=10`;
  const response = await axios.get(
    `${userMicroserviceBaseURL}/Staff/GetGlobalStaff?${createStringForParams(
      params,
    )}`,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}

export async function getGlobalStaffDetail(params) {
  const response = await axios.get(
    `${userMicroserviceBaseURL}/Staff/GetGlobalStaffDetail?${createStringForParams(
      params,
    )}`,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}

export const addGlobalStaff = async (params) => {
  const response = await axios.post(
    `${userMicroserviceBaseURL}/Staff/AddGlobalStaff`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
};
export const updateBulkStaff = async (params) => {
  const response = await axios.put(
    `${userMicroserviceBaseURL}/Staff/UpdateEmploymentDetails?`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
};
//       Method: Patch
// {{userBaseUrl}}/api/v1/Staff/BulkUpdateStatus
staffRepository.bulkUpdateStatusActivateOrDeactivate = async (params) => {
  const response = await axios.patch(
    `${userMicroserviceBaseURL}/Staff/BulkUpdateStatus`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
};

// Method: Post
// {{userBaseUrl}}/api/v1/Staff/BulkRemove
staffRepository.bulkRemove = async (params) => {
  const response = await axios.post(
    `${userMicroserviceBaseURL}/Staff/BulkRemove`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
};

// Method: POST
// {{userBaseUrl}}/api/v1/Staff/RenotifyPendingStaff

staffRepository.renotifyPendingStaff = async (params) => {
  const response = await axios.post(
    `${userMicroserviceBaseURL}/Staff/RenotifyPendingStaff`,
    params,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
};
//     Method: Delete
// {{userBaseUrl}}/api/v1/Staff/RemoveInvitations?ownerId=5911&userId=5112&officeIds=5501
staffRepository.removeInvitations = async (requestQueryParams) => {
  const response = await axios.delete(
    `${userMicroserviceBaseURL}/Staff/RemoveInvitations?` + requestQueryParams,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
};
export default staffRepository;

export const downloadTemplateXL = async (ownerId, isGlobal, officeId) => {
  const response = await axios.get(
    `${userMicroserviceBaseURL}/Staff/GetSampleXL?ownerId=${ownerId}&isGlobal=${isGlobal} ${
      officeId ? `&officeId=${officeId}` : ""
    }`,
  );
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data.data;
};

export const uploadStaffCsv = async (file, ownerId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("OwnerId", ownerId);
  const response = await axios.post(
    `${userMicroserviceBaseURL}/Staff/upload-csv`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  if (response.data.statusCode !== 200) {
    throw new Error(
      response.data?.message || response.data?.data || "Failed to upload file",
    );
  }
  if (response.data.data) {
    response.data.data.fileName = file?.name;
  }
  return response.data.data;
};
